export default "__VITE_ASSET__B72EEAWS__"